module.exports = __webpack_public_path__ + "img/call-ico.1d1d1bb4.svg";